import {
  predatadownloadhandler,
   POST
} from "./querydata";
import {
  ElMessageBox,
  ElMessage
} from "element-plus";
import {
  des
} from "./des";
import {
  login
} from "./userhandler";



//重新登陆
export const relogin = (username) => {
  ElMessageBox.prompt("Please input passwd", "Session Time out", {
    confirmButtonText: "OK",
    inputPlaceholder: "Password",
    inputType: "password",
    inputValidator: (value) => {
      // 点击按钮时，对文本框里面的值进行验证
      if (!value) {
        return "empty passwd";
      }
    },
  }).then((value) => {
    //用账号密码登陆
    let passwd = des("tuiguang", value.value, 1, 0);

    login(username, passwd).then((res) => {
      if (res.data.status == "1") ElMessage.success("Login successful");
      else ElMessage.error("Login failed");
    });
  });
};



export async function downloadfile(granuleid, username) {
  predatadownloadhandler(granuleid).then((res) => {
    if (res.status == 200) {
      if (res.data.status == "1") {
        //登陆成功、文件准备好了
        var p = new Array();
        p.push({
          name: "granuleid",
          value: granuleid
        });
        p.push({
          name: "cmdtype",
          value: "datadownload"
        });
        
        // var p2=new Array();
        // p2.push({
        //   name: "granuleid",
        //   value: 'GF1_WFV1_E101.1_N19.6_20211215_L1A0006138357'
        // });
        // p2.push({
        //   name: "cmdtype",
        //   value: "datadownload"
        // });

        POST("datadownload", p); //数据下载
     //   POST("datadownload", p2); //数据下载
      } else {
        if (res.data.file == "0") ElMessageBox.alert('File Download Failed!', {
          type: "warning"
        })
        else relogin(username);
      }
    }
  });
}

